export default __webpack_public_path__ + "static/media/nose.70400f8e.png";